import {default as TokenProvider} from "./TokenProvider"
import {httpClient} from "Config";

export const tokenProvider  = new TokenProvider(httpClient)